import * as Sentry from '@sentry/react';
import filestack from 'filestack-js';
import _ from 'lodash';
import {filestackUploadPolicy} from 'shared/core';

const openFileStack = (params, onUpdate) => {
  const client = filestack.init(import.meta.env.VITE_FILESTACK_KEY, filestackUploadPolicy);

  const pick = _.defaultsDeep(params, {
    accept: ['.apng', '.png', '.avif', '.gif', '.jpg', '.jpeg', '.jfif', '.pjpeg', '.pjp', '.webp'],
    fromSources: [
      'local_file_system',
      'googledrive',
      'onedrive',
      'dropbox',
    ],
    storeTo: {
      location: 's3'
    }
  });

  client.pick(pick).then(response => {
    const file = _.head(response.filesUploaded);
    if (file) {
      onUpdate({
        fileName: file.filename,
        fileSize: file.size,
        contentType: file.mimetype,
        key: file.key,
        label: file.url,
      });
    } else {
      Sentry.captureMessage('FileStack upload failed.', {extra: response});
    }
  });
};

export default openFileStack;
